export { default as Header } from './Header';
export { default as SettingsDrawer } from './SettingsDrawer';
export { default as SideMenuDrawer } from './SideMenuDrawer/SideMenuDrawer';
export { default as Main } from './Main';
export { default as DrawerHeader } from './DrawerHeader';

export const drawerWidth = 240;
